module.exports = __webpack_public_path__ + "img/Wp_2011.7faee587.png";